import { render, staticRenderFns } from "./AllOverduePayment.vue?vue&type=template&id=1e2ca874&scoped=true&"
import script from "./AllOverduePayment.vue?vue&type=script&lang=js&"
export * from "./AllOverduePayment.vue?vue&type=script&lang=js&"
import style0 from "./AllOverduePayment.vue?vue&type=style&index=0&id=1e2ca874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ca874",
  null
  
)

export default component.exports